import { NO_SHOW_GRACE_MINUTES_AFTER_START } from './dateUtils';

export function getNoShowInvoiceErrorMessage(err) {
  const code = err?.code || err?.responseData?.code;
  if (code === 'NO_SHOW_INVOICE_NO_EMAIL') return 'Keine E-Mail-Adresse hinterlegt';
  if (code === 'NO_SHOW_INVOICE_NO_ADYEN_MERCHANT')
    return 'Für diesen Standort ist kein Adyen Merchant hinterlegt';
  if (code === 'NOSHOW_INVOICE_ALREADY_SENT') return 'No-Show-Rechnung wurde bereits versendet';
  if (code === 'NO_SHOW_INVOICE_ALREADY_PAID') return 'Buchung ist bereits bezahlt';
  if (code === 'NO_SHOW_INVOICE_NO_LINE_ITEMS')
    return 'Keine abrechenbaren Positionen für die No-Show-Rechnung';
  if (code === 'BOOKING_NOT_ENDED_YET')
    return `No-Show-Rechnung kann erst ${NO_SHOW_GRACE_MINUTES_AFTER_START} Minuten nach geplantem Beginn versendet werden`;
  if (code === 'BOOKING_ALREADY_CHECKED_IN') return 'Buchung ist bereits eingecheckt';
  if (code === 'BOOKING_NOT_NO_SHOW') return 'Buchung muss den Status „No-Show" haben';
  return 'Fehler beim Versenden der No-Show-Rechnung';
}
